import { debounce, throttle } from 'lodash';
import domReady from '../helpers/dom-ready';

class ScrollIndicators {
  static init() {
    return new ScrollIndicators();
  }

  constructor() {
    this.scrollIndicatorBar = document.querySelector('.scroll-indicator');
    this.positionBlock = document.querySelector('.indicator-position-block');
    this.scrollArrow = document.querySelector('.scroll-arrow');
    this.footer = document.querySelector('footer');
    this.scrollWrapper = document.querySelector('.parallax-wrapper');

    if (this.scrollIndicatorBar && this.positionBlock) this.calculateScrollPosition();
    if (this.scrollArrow) this.toggleScrollArrowVisibility();

    window.addEventListener('scroll', throttle(() => {
      if (this.scrollIndicatorBar && this.positionBlock) this.calculateScrollPosition();
      if (this.scrollArrow) this.toggleScrollArrowVisibility();
    }), 50);

    window.addEventListener('resize', debounce(() => {
      if (this.scrollIndicatorBar && this.positionBlock) this.calculateScrollPosition();
      if (this.scrollArrow) this.toggleScrollArrowVisibility();
    }), 50);
  }

  calculateScrollPosition() {
    const { height: footerHeight } = this.footer.getBoundingClientRect();
    const { y: offsetY } = this.scrollIndicatorBar.getBoundingClientRect();
    const scrollHeight = document.body.scrollHeight - window.innerHeight;
    const percentPosition = Math.round((document.body.scrollTop / scrollHeight) * 10);
    const isAboveFooter = (scrollHeight - footerHeight) - document.body.scrollTop > 0;
    const isFixed = this.scrollIndicatorBar.classList.contains('-fixed');

    // space height + line height = 33
    const transY = percentPosition > 0 ? (percentPosition - 1) * 33 : 0;
    this.positionBlock.style.transform = `translate(0, ${transY}px)`;

    if (isAboveFooter && !isFixed) {
      this.scrollIndicatorBar.classList.add('-fixed');
      this.scrollIndicatorBar.removeAttribute('style');
    } else if (!isAboveFooter && isFixed) {
      this.scrollIndicatorBar.classList.remove('-fixed');
      this.scrollIndicatorBar.style.top = `${scrollHeight - footerHeight + offsetY}px`;
    }
  }

  toggleScrollArrowVisibility() {
    let scrollPosition = document.documentElement.scrollTop;
    if (document.body.classList.contains('powerfoyle')) {
      scrollPosition = this.scrollWrapper.scrollTop;
    }
    if (scrollPosition < 10 && this.scrollArrow.classList.contains('-hide')) {
      this.scrollArrow.classList.remove('-hide');
    } else if (scrollPosition >= 10 && !this.scrollArrow.classList.contains('-hide')) {
      this.scrollArrow.classList.add('-hide');
    }
  }
}

domReady(() => {
  ScrollIndicators.init();
});
